import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import type { Resolver } from 'react-hook-form';
import { creativeTextLocalizationsFieldSchema } from './creativeTextLocalizationsValidator';

const schema = z.object({
  text: z.string().min(1, "Can't be empty"),
  language: z.string().min(1, "Can't be empty"),
  default_flow_id: z.number().optional(),
  localizations: creativeTextLocalizationsFieldSchema,
});

export default {
  schema,
  resolver: zodResolver(schema),
} as {
  schema: typeof schema;
  resolver: Resolver<z.infer<typeof schema>>;
};
